import { render } from "./comparerates.vue?vue&type=template&id=5e201054"
import script from "./comparerates.js?vue&type=script&lang=js"
export * from "./comparerates.js?vue&type=script&lang=js"

import "./comparerates.vue?vue&type=style&index=0&id=5e201054&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__